var React = require('react');

function Failed (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#212121","d":"M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"}));
}

Failed.defaultProps = {"width":"70","height":"70","viewBox":"0 0 24 24"};

module.exports = Failed;

Failed.default = Failed;
